const ptBR = {
  language: "Idioma",
  english: "Inglês",
  portuguese: "Português",
  spanish: "Espanhol",
  logout: "Sair",
  login: "Login",
  loginPage: "Entrar",
  welcome: "Bem vindo",
  save: "Salvar",
  backToSearch: "Voltar para pesquisa",
  backToDetails: "Voltar para detalhes",
  delete: "Excluir",
  update: "Atualizar",
  edit: "Editar",
  new: "Novo",
  newA: "Novo (a)",
  search: "Pesquisar",
  total: "Total",
  itensFound: "itens encontrados",
  registersPerPage: "registros por página",
  ofPages: "de {0} páginas",
  yes: "Sim",
  no: "Não",
  select: "Selecione",
  name: "Nome",
  code: "Código",
  close: "Fechar",
  date: "Data",
  user: "Usuário",
  details: "Detalhes",
  email: "E-mail",
  column: "Coluna",
  warning: "Aviso",
  menu: "Menu",
  form: "Form",
  itemSuccessfullyCreated: "Item criado com sucesso",
  itemSuccessfullyUpdated: "Item atualizado com sucesso",
  confirmTheDeletion: "Confirma a exclusão?",
  itemDeleted: "Item removido.",
  error: "Erro",
  unexpectedError: "Erro inesperado!",
  anUnexpectedErrorOccurred: "Ocorreu um erro inesperado:",
  ServerNotAvailable: "Servidor não disponivel!",
  theUrlAccessedDoesNotBelongToAnyTenant: "A url acessada não pertence a nenhum Tenant",
  success: "Sucesso",
  value: "Value",
  label: "Label",
  maximumSize: "Tamanho máximo",
  maximumValue: "Valor máximo",
  minimumSize: "Tamanho mínimo",
  minimumValue: "Valor mínimo",
  required: "Requerido",
  suffix: "Sufixo",
  users: "Usuários",
  backToList: "Voltar para lista",
  phone: "Telefone",
  enabled: "Habilitado?",
  noItemsFound: "Nenhum item encontrado",
  item: "Item",
  contactUs: "Fale conosco",
  cpf: "CPF",
  cnpj: "CNPJ",
  invalid: "inválido",
  pleaseFillInTheField: "Por favor, preencha o campo",
  bothFieldsAreRequired: "Os dois campos são obrigatórios!",
  profile: "Perfil",
  changePassword: "Troca de senha",
  currentPassword: "Senha atual",
  newPassword: "Nova senha",
  repeatNewPassword: "Repita a nova senha",
  passwordExpired: 'Senha expirada',

  username: "Nome de usuário",
  password: "Senha",
  documentNumber: "Número de documento",
  actions: 'Ações',
  chooseAFile: 'Escolha um arquivo.',
  version: 'Versão',
  sgs_render_file_error_upload: "Ocorreu um erro, o arquivo não foi enviado"
};

export default {
  ...ptBR
};



// WEBPACK FOOTER //
// ./src/i18n/pt-br.js